import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Radio } from 'antd';
import UIValue from './uiValue';
import UIValidation from './uiValidation';
function BinaryRadioComponent(props) {
    const [value, setValue] = useState(props.value ?? props.option1Value);
    useEffect(() => {
        if (props.value !== undefined) {
            setValue(props.value);
        }
    }, [props.value]);
    const handleChange = (e) => {
        const v = e.target.value;
        setValue(v);
        props.onChange(v);
    };
    const activeColor = props.activeColor || '#f59e0b'; // Tailwind amber-500
    return (_jsx("div", { style: props.styling, children: _jsxs(Radio.Group, { onChange: handleChange, value: value, style: { width: props.sectionWidth, display: 'flex', justifyContent: 'space-around' }, children: [_jsx(Radio, { value: props.option1Value, style: { color: value === props.option1Value ? activeColor : undefined } }), _jsx(Radio, { value: props.option2Value, style: { color: value === props.option2Value ? activeColor : undefined } })] }) }));
}
export default class UIBinaryRadio extends UIValue {
    option1Label;
    option1Value;
    option2Label;
    option2Value;
    activeColor;
    sectionWidth;
    onChange;
    style;
    constructor(s) {
        super(s);
        const legacyTrue = this.getProperty('trueLabel', 'True');
        const legacyFalse = this.getProperty('falseLabel', 'False');
        this.option1Label = this.getProperty('option1Label', legacyTrue);
        this.option2Label = this.getProperty('option2Label', legacyFalse);
        this.option1Value = this.getProperty('option1Value', 'true');
        this.option2Value = this.getProperty('option2Value', 'false');
        this.activeColor = this.getProperty('activeColor', '#f59e0b');
        this.sectionWidth = this.getProperty('sectionWidth', '0px');
        this.style = this.getProperty('style', '');
        if (this.value === undefined || this.value === '') {
            this.value = this.option1Value;
        }
    }
    getComponent() {
        const onChange = (v) => {
            this.value = v;
            this.error = undefined;
            // Call the public onChange handler if it exists
            if (this.onChange) {
                this.onChange(v);
            }
        };
        const props = {
            option1Label: this.option1Label,
            option1Value: this.option1Value,
            option2Label: this.option2Label,
            option2Value: this.option2Value,
            activeColor: this.activeColor,
            sectionWidth: this.sectionWidth,
            value: this.value,
            onChange: onChange,
            styling: this.style,
        };
        return (_jsx(UIValidation, { error: this.error, children: _jsx(BinaryRadioComponent, { ...props }) }));
    }
}
//# sourceMappingURL=uiBinaryRadio.js.map